// extracted by mini-css-extract-plugin
module.exports = {"termsOfUseContainer":"termsOfUse_termsOfUseContainer__198JA","termsOfUseBody":"termsOfUse_termsOfUseBody__1BL6f","primaryColor":"termsOfUse_primaryColor__f9fbz"};